export const KEY_CODES = Object.freeze({
  enter: 13,
  escape: 27,
  space: 32,
  tab: 9,
});
